import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({ palette: { text }, spacing: { unit } }: Theme) =>
  createStyles({
    content: {
      padding: `${unit * 3}px !important`,
    },
    text: {
      color: text.primary,
      fontWeight: 500,
    },
  });
